<template>
   <router-link
   :to="to"
   class="px-3 lg:px-6 py-5 border-b-2 border-transparent hover:text-primary transition transition-colors duration-200 text-support-500 font-semibold"
   active-class="border-awro-600 text-awro-600"
   exact
   >
        <slot/>
   </router-link>
</template>

<script>
export default {
    name: "NavLink",
    props: ['to']
}
</script>
